import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {

  constructor() { }

  /**
   * Scroll to element
   * @param selector ".class", "#id", ...
   */
  scrollTo(selector: string):void{
    $('html, body').animate({
      scrollTop: $(selector).offset().top - $('.header__container').height()
    }, 750);
  }
  /**
   * Scroll to element en passant en element jquery en param
   * @param selector elem jquery
   */
  scrollToJqueryElem($elem: any):void{
    $('html, body').animate({
      scrollTop: $elem.offset().top - $('.header__container').height()
    }, 750);
  }
  

}



// WEBPACK FOOTER //
// ./src/app/helper/utils/utils.service.ts